import { render } from "./LegalNotices.vue?vue&type=template&id=05290980&scoped=true"
import script from "./LegalNotices.vue?vue&type=script&lang=js"
export * from "./LegalNotices.vue?vue&type=script&lang=js"

import "./LegalNotices.vue?vue&type=style&index=0&id=05290980&lang=scss&scoped=true"

import exportComponent from "/Users/skynet/Documents/Sites safe 2026/Safe_Sites_Modifs/SAFE_GROUP/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05290980"]])

export default __exports__